import { Card } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

export function ItemCardSkeleton() {
  return (
    <Card className="flex flex-row overflow-hidden sm:flex-col bg-gradient-to-br from-slate-50 to-slate-100 dark:from-gray-800/60 dark:to-gray-700/60 border border-slate-200 dark:border-gray-600/50 py-0 animate-pulse">
      <div className="w-1/3 shrink-0 sm:w-auto">
        <div className="flex h-full items-center justify-center bg-gradient-to-br from-white to-slate-50 dark:from-gray-700/40 dark:to-gray-600/40 px-0 py-2 sm:border-b border-slate-200/50 dark:border-gray-600/30">
          <Skeleton className="max-h-[120px] w-[100px] rounded-xl sm:h-[200px] sm:w-[200px] sm:max-h-none" />
        </div>
      </div>
      <div className="mt-1 mb-2 flex min-w-0 flex-1 flex-col sm:w-auto sm:flex-initial px-3">
        <Skeleton className="h-6 w-16 rounded-lg" />
        <Skeleton className="mt-1 h-4 w-20 rounded-lg" />
        <Skeleton className="mt-2 h-4 w-full rounded-lg" />
        <Skeleton className="mt-1 h-4 w-3/4 rounded-lg" />
        <Skeleton className="mt-2 h-12 w-full rounded-lg" />
        <div className="mt-auto flex w-full gap-2 pb-1">
          <div className="h-10 w-10 rounded-lg bg-gradient-to-r from-orange-200 to-orange-300 dark:from-orange-800/40 dark:to-orange-900/40" />
          <div className="h-10 flex-1 rounded-lg bg-gradient-to-r from-blue-200 to-indigo-200 dark:from-blue-800/40 dark:to-indigo-800/40" />
        </div>
      </div>
    </Card>
  );
}
